import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatCollectAmountRangeModel } from 'src/app/model/cat-collect-amount-range.model';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { CatCollectAmountRangeService } from 'src/oldApp/services/cat-collect-amount-range.service';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { CreatorService } from 'src/app/services/creator.service';
import { ModalCollectAmountRangeComponent } from 'src/oldApp/shared/modal-collect-amount-range/modal-collect-amount-range.component';

@Component({
  selector: 'app-cat-collect-range-amount',
  templateUrl: './cat-collect-range-amount.component.html',
  styleUrls: ['./cat-collect-range-amount.component.css']
})
export class CatCollectRangeAmountComponent implements OnInit {
  // estado pagina
  public page:string='CatGoalRegion';
  public viewStatus=0;  // -1:nada, 0:spinner, 1:tabla
  public ranges:CatCollectAmountRangeModel[]=[];

  // catalogs
  public employeeJobCatalog:CatEmployeeJobModel[];
  public collectAmountGroupCatalog:any[]=[
    {id:1, description:'Grupo 1'},
    {id:2, description:'Grupo 2'}
  ];

  // opciones datatables
  dtOptions={
    order:[],
    responsive:true,
    columnDefs: [
      { responsivePriority: 1, width:100, targets: -1 }
    ],
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth:false,
    // pagingType: 'full_numbers',
    paging:true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  /////////////////
  constructor(
    private creator:CreatorService,
    private modalService:NgbModal,
    private catCollectAmountRangeService:CatCollectAmountRangeService,
    private catEmployeeJobService:CatEmployeeJobService,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  // 
  add=()=> {
    let range=this.creator.newCatGoalRegion();
    let modalRef=this.modalService.open(ModalCollectAmountRangeComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.range={...range};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='create';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }
  edit=(range:CatCollectRangeAmountComponent)=> {
    let modalRef=this.modalService.open(ModalCollectAmountRangeComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.range={...range};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='edit';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }

  // HELPERS
  jobDescription=range=> {
    let emp=this.employeeJobCatalog.find(e=> e.employeeJobId===range.employeeJobId);
    return emp?emp.description:'';
  }
  groupDescription=range=> {
    let group=this.collectAmountGroupCatalog.find(g=> g.id===range.collectAmountGroupId);
    return group?group.description:'';
  }

  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.catCollectAmountRangeService.getAll(),
      this.catEmployeeJobService.getAll()
    )
    .pipe(
      tap(([rangesResp, jobsResp]:[any, any])=> {
        this.ranges=rangesResp.data;
        this.employeeJobCatalog=jobsResp.data;
        this.viewStatus=1;
      }),
      catchError(error=> {
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al leer el catálogo de regiones.'));
      })
    )
    .subscribe();
  }
}
